export const formatGameStartTime = (timestampDate: number) => {
  return new Date(timestampDate * 1000).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
